module.exports = __webpack_public_path__ + "img/brand_logo_jeep.784bb84c.png";